import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t bg-white">
      <div className="max-w-6xl mx-auto px-6 py-10 grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <a href="#" className="flex items-center gap-3 text-slate-900 hover:text-slate-700">
            <img src="/logo-icon.png" alt="Life Bricks" className="h-6 w-auto" />
            <span className="font-semibold">Life Bricks</span>
          </a>
          <p className="text-sm text-slate-600 mt-4">Built with care. Designed for intentional living.</p>
        </div>
        <div>
          <h5 className="font-semibold mb-2 text-slate-900">Resources</h5>
          <ul className="text-sm text-slate-600 space-y-2">
            <li><a href="#about" className="text-slate-600 hover:text-slate-800">About</a></li>
            <li><a href="#help" className="text-slate-600 hover:text-slate-800">Help</a></li>
            <li><a href="#features" className="text-slate-600 hover:text-slate-800">Features</a></li>
          </ul>
        </div>
        <div>
          <h5 className="font-semibold mb-2 text-slate-900">Support</h5>
          <ul className="text-sm text-slate-600 space-y-2">
            <li><a href="https://lifebricks.slack.com/" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-slate-800">Contact</a></li>
            <li><a href="#faq" className="text-slate-600 hover:text-slate-800">FAQ</a></li>
            <li><a href="https://buymeacoffee.com/lifebricks.ai" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-slate-800">Contributions</a></li>
          </ul>
        </div>
      </div>
      <div className="text-center text-sm text-slate-500 py-4">© {currentYear} Life Bricks. All rights reserved.</div>
      <div className="max-w-6xl mx-auto px-6 text-xs text-slate-500 py-4">
        <p>Disclaimer: All AI-generated content is for advisory purposes only and should not be considered medical, financial, or professional advice.</p>
        <p className="mt-2">Licensed under the GNU General Public License v3.0. Contributions welcome 🎉</p>
        <div className="mt-4 flex justify-center">
          <a 
            href="https://buymeacoffee.com/lifebricks.ai" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block"
          >
            <img 
              src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" 
              alt="Buy Me A Coffee" 
              className="h-12 w-auto hover:opacity-80 transition-opacity"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
